class Popup {
    constructor(element) {
        this.element = element
        this.initListeners()
    }

    initListeners() {
        $('body').on('click', (event) => {
            if (!event.target.closest('.js-sort')) {
                this.closePopup()
            }
        })

        $(window).on('keyup', (event) => {
            if (event.keyCode === 27) {
                this.closePopup()
            }
        })
    }

    togglePopup() {
        $(this.element).toggle()
    }

    closePopup() {
        $(this.element).hide()
    }

}

$('.js-popup').each((index, item) => {
    item._popup = new Popup(item)
})

$('body').on('click', '.js-popup-toggle' , (event) =>  {
    const target = event.target.closest('.js-popup-toggle')
    findPopup(target).togglePopup()
})

const findPopup = (button) => {
    const popupId = $(button).data('popup-id')
    return $(`.js-popup[data-popup-id="${popupId}"]`)?.[0]?._popup
}

